import { render } from "./socialIcons.vue?vue&type=template&id=a5c06298&scoped=true"
const script = {}

import "./socialIcons.vue?vue&type=style&index=0&id=a5c06298&scoped=true&lang=css"

import exportComponent from "C:\\Users\\amaan\\encanto-new\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a5c06298"]])

export default __exports__